document.addEventListener("DOMContentLoaded", function () {

// ================= START : Accordion Tooggle Home page Section JS ===========================

  const accordionItems = document.querySelectorAll(".accordion-content");

  accordionItems.forEach(item => {
    const question = item.querySelector(".faq-question");
    const answer = item.querySelector(".faq-answer");
    const iconContainer = question.querySelector(".faq-toggle-icon");

    question.addEventListener("click", function () {
      const isOpen = answer.style.display === "flex";

      accordionItems.forEach(i => {
        i.querySelector(".faq-answer").style.display = "none";
        i.querySelector(".faq-question").setAttribute("aria-expanded", "false");
        const icon = i.querySelector(".faq-toggle-icon");
        icon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M5.5 6.5H0V5.5H5.5V0H6.5V5.5H12V6.5H6.5V12H5.5V6.5Z" fill="black"/>
        </svg>
        `;
      });

      if (!isOpen) {
        answer.style.display = "flex";
        question.setAttribute("aria-expanded", "true");
        iconContainer.innerHTML = `
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M5 13V12H18V13H5Z" fill="#2E2E2E"/>
        </svg>
        `;
      }
    });
  });

// ================= END : Accordion Tooggle Home page Section JS ===========================


// ================= START: Product page Accordion JS ========================
  const productaccodion = document.querySelectorAll(".product-accordion-content");
    productaccodion.forEach((accordion) => {
      accordion.addEventListener("click", () => {

        const question = accordion.querySelector(".product-faq-question");
        const answer = accordion.querySelector(".product-faq-answer");
        const icon = accordion.querySelector(".product-faq-toggle-icon");

        const isOpen = question.getAttribute("aria-expanded") === "true";

        // aria toggle
        question.setAttribute("aria-expanded", !isOpen);

        // answer display
        answer.style.display = isOpen ? "none" : "flex";

        // icon change
        icon.innerHTML = isOpen
          ? `
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <path d="M5.5 6.5H0V5.5H5.5V0H6.5V5.5H12V6.5H6.5V12H5.5V6.5Z" fill="black"/>
          </svg>`
          : `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M5 13V12H18V13H5Z" fill="#2E2E2E"/>
          </svg>`;
      });
    });

  const parents = document.querySelectorAll(".product-accordion-section .product-accordion-content[data-parent-index]");
    if(parents.length > 0){
      parents.forEach(parent => {
        const parentIndex = parent.getAttribute("data-parent-index");
        const matchingChildren = document.querySelectorAll(
            `[data-child-index="${parentIndex}"]`
          );
          if (matchingChildren.length > 0) {
            const parentContent = parent.querySelector(".product-faq-answer");
              if (parentContent) {
                matchingChildren.forEach(child => {
                  child.classList.add("accordion-sub-child");
                  parentContent.appendChild(child);  
                });
              }
          }
      });
    }

  // FIX FOR SUB ACCORDION CLICK
  document.querySelectorAll(".product-accordion-content.accordion-sub-child").forEach(subAccordion => {
    const question = subAccordion.querySelector(":scope > .product-faq-question");
    const answer = subAccordion.querySelector(":scope > .product-faq-answer");
    const icon = subAccordion.querySelector(".product-faq-toggle-icon");

    question.addEventListener("click", (e) => {
      e.stopPropagation(); 
      const isOpen = question.getAttribute("aria-expanded") === "true";

      // toggle aria
      question.setAttribute("aria-expanded", !isOpen);

      // toggle answer
      answer.style.display = isOpen ? "none" : "flex";

      // toggle icon
      icon.innerHTML = isOpen
        ? `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
          <path d="M5.5 6.5H0V5.5H5.5V0H6.5V5.5H12V6.5H6.5V12H5.5V6.5Z" fill="black"/>
        </svg>`
        : `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M5 13V12H18V13H5Z" fill="#2E2E2E"/>
        </svg>`;
    });
  });


// ================= END: Product page Accordion JS ========================

// ================= START : Image Banner  Button JS ===========================

  const button = document.querySelector('.image-banner-contain .image-banner-btn');

  if (button) {
    button.addEventListener('click', function() {
      console.log('Clicked');

      const target = document.querySelector('.feature-product-wrapper');
      if (target) {
        // Smooth scroll to target
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

// ================= END : Image Banner  Button JS ===========================


// ================= START : Mobile Megamenu Product JS ===========================

  // const wrapper = document.querySelector('.mega-nav-product-wrapper');

  // if (wrapper && wrapper.querySelectorAll('.swiper-slide').length > 0) {
  //   new Swiper(wrapper, {
  //     slidesPerView: 2,
  //     spaceBetween: 10,
  //     navigation: {
  //       nextEl: wrapper.querySelector('.swiper-button-next'),
  //       prevEl: wrapper.querySelector('.swiper-button-prev'),
  //     },
  //     pagination: {
  //       el: wrapper.querySelector('.swiper-pagination'),
  //       clickable: true,
  //     },
  //   });
  // }
// ================= END : Mobile Megamenu Product JS ===========================

// ================= START : Review Slider JS ==========================

  const mobwrapper = document.querySelector('.header-megamenu-review-wrapeer');

  if (mobwrapper && mobwrapper.querySelectorAll('.swiper-slide').length > 0) {
    new Swiper(mobwrapper, {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: mobwrapper.querySelector('.swiper-button-next'),
        prevEl: mobwrapper.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: mobwrapper.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }

// ================= END : Review Slider JS ==========================


// ================ Start : Collection page Add to cart   ==================  

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".product-list-item-ajax-button");
  if (!btn) return;
  e.preventDefault();
  let sellingPlanId = btn.dataset.sellingPlan || null;
  btn.classList.add("Adding");
  btn.disabled = true;
  const variantID = btn.value;
  const qty = 1;
  addItemToCart(variantID, btn, qty, sellingPlanId);

});

// ================ End : Collection page Add to cart   ==================  


// ================ Start : Offer product Add to cart   ==================  

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".offer-add-to-order");
  if (!btn) return;

  e.preventDefault();

  let sellingPlanId = null;
  btn.classList.add("Adding");
  btn.disabled = true;

  const variantID = btn.value;
  const qty = 1;

  console.log('variantID ', variantID);

  addItemToCart(variantID, btn, qty, sellingPlanId);
});

// ================ end : Offer product Add to cart   ==================  

// ================ Start : Add to cart fucntion  ==================  

function addItemToCart(variantID, btn, qty, sellingPlanId = null) {

  if (!variantID) return;

  const item = {
    id: parseInt(variantID, 10),
    quantity: qty
  };

  if (sellingPlanId) {
    item.selling_plan = sellingPlanId;
  }

  const body = {
    items: [item]
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify(body)
  })
    .then(res => res.json())
    .then(data => {

      if (btn) {
        btn.classList.remove("Adding");
        btn.disabled = false;
      }

      const cartType = document.body.getAttribute('data-cart-type');

      if (cartType === 'drawer') {
        refreshCartDrawer();

        // 🔥 Drawer open thoda delay ke baad
        setTimeout(() => {
          openCartDrawer();
        }, 300);
      }

    })
    .catch(err => {
      console.error("Add to Cart Error:", err);
    });
}

function refreshCartDrawer() {
  fetch('/cart')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newDrawer = doc.querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.replaceWith(newDrawer);
      }
    })
    .catch(err => {
      console.error('Cart drawer refresh failed:', err);
    });
}

// ================ end : Add to cart fucntion  ================== 


// ================ ******************** Start : PDP JS ******************  ================== 



  if (document.body.classList.contains('morning-routine')) {
    const options = document.querySelectorAll('.custom-option-selector .custom-options');

    // Add a click event listener to each option
    options.forEach(option => {
      option.addEventListener('click', function() {
        // Remove 'selected' from all options
        options.forEach(opt => opt.removeAttribute('selected'));

        // Add 'selected' to the clicked option
        this.setAttribute('selected', '');

        // Optional: do something with the clicked value
        const selectedValue = this.getAttribute('value');
        console.log('Selected option:', selectedValue);
      });
      });
    // ================ START : Quantity And Add to Cart Wrap JS ==============

      const quantityDiv = document.querySelector('.product__grid-right .product-quantity');
      const productFormDiv = document.querySelector('.product__grid-right .product-form');

      if (quantityDiv && productFormDiv) {
          const wrapDiv = document.createElement('div');
          wrapDiv.className = 'quantity-add-wrapper';

          // Insert the wrapper before quantityDiv
          quantityDiv.parentNode.insertBefore(wrapDiv, quantityDiv);

          // Move the quantity and form elements inside the wrapper
          wrapDiv.appendChild(quantityDiv);
          wrapDiv.appendChild(productFormDiv);
      }

    // ================ END : Quantity And Add to Cart Wrap JS ===============

    // ================ START : Richarge Widget design  ================== 
    
    const rcInterval = setInterval(() => {
      const rcWidget = document.querySelector(".recharge-subscription-widget .rc-widget");
      const label = document.querySelector("label.rc-radio");
      const input = label?.querySelector("input.rc-radio__input");
      const title = label?.querySelector(".rc-radio__label");
      const sellingPlans = label?.querySelector(".rc-selling-plans");
      const priceEl = label?.querySelector(".rc-radio__price");

      if (!label || !input || !title || !sellingPlans) return;

      // already wrapped? stop
      if (label.querySelector(".rc-radio-header")) {
        clearInterval(rcInterval);
        return;
      }

      //  Create wrapper
      const header = document.createElement("div");
      header.className = "rc-radio-header";

      // Move input + title inside wrapper
      header.appendChild(input);
      header.appendChild(title);

      //  Insert wrapper at top
      label.insertBefore(header, sellingPlans);


      /* -------- BEST VALUE TAG -------- */
      const badge = document.createElement("span");
      badge.className = "rc-best-tag";
      badge.textContent = "Best Value";

      // wrap title + badge vertically
      const titleWrap = document.createElement("div");
      titleWrap.className = "rc-title-wrap";

      title.parentNode.insertBefore(titleWrap, title);
      titleWrap.appendChild(title);
      titleWrap.appendChild(badge);

      /* ---------- PRICE CALC ---------- */
      
      const monthlyPrice = parseFloat(
        priceEl.textContent.replace(/[^0-9.]/g, "")
      );

      if (!monthlyPrice) return;

      const activeProduct = document.querySelector(
        ".custom-routine-product-item.active"
      );

      const productForm = document.querySelector(".product-wrap form");
      const productId = productForm?.dataset.productid;

      let perStick;

      if (productId === "7604789968942") {
        perStick = "1.10";
      } else if (productId === "4652192137262") {
        perStick = "1.32";
      } else if (productId === "7520165789742") {
        perStick = (monthlyPrice / 90).toFixed(2);
      } else {
        perStick = (monthlyPrice / 30).toFixed(2);
      }

      const unitLabel = productId === "7520165789742"
      ? "Serving"
      : "Stick Pack";


    /* ---------- TOP RIGHT PRICE (/month) ---------- */

      const monthPrice = document.createElement("div");
      monthPrice.className = "rc-month-price";
      monthPrice.innerHTML = `<strong>$${monthlyPrice}</strong><span>/month</span>`;
      header.appendChild(monthPrice);

    /* ---------- EXTRA CONTENT ---------- */
      const extra = document.createElement("div");
      extra.className = "rc-extra-ui";

      extra.innerHTML = `
        <div class="rc-sub-price">
          <span class="rc-stick-price-wrap">
            <span class="rc-stick-price">$${perStick}</span> / ${unitLabel} +
          </span>
          <span class="rc-free">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M21.8467 11.9666L19.2608 7.72061C19.1995 7.61834 19.0895 7.55612 18.9702 7.55612H16.0725V6.66806C16.0725 6.47971 15.92 6.32715 15.7316 6.32715H6.50144C6.31308 6.32715 6.16053 6.47971 6.16053 6.66806C6.16053 6.85641 6.31308 7.00897 6.50144 7.00897H15.3906V15.2743H10.4449C10.2505 14.2619 9.36162 13.4939 8.29371 13.4939C7.2258 13.4939 6.33603 14.2618 6.14257 15.2743H4.51474C4.32639 15.2743 4.17383 15.4269 4.17383 15.6153C4.17383 15.8036 4.32639 15.9562 4.51474 15.9562H6.12723C6.26189 17.0377 7.17553 17.8806 8.29371 17.8806C9.41104 17.8806 10.3255 17.0377 10.4602 15.9562H15.6191C15.7844 17.0028 16.6853 17.8082 17.7779 17.8082C18.8705 17.8082 19.7714 17.0028 19.9367 15.9562H21.5569C21.7452 15.9562 21.8978 15.8036 21.8978 15.6153V12.144C21.8969 12.0809 21.8791 12.0203 21.8467 11.9666ZM8.29304 17.1986C7.45952 17.1986 6.78195 16.5211 6.78195 15.6876C6.78195 14.854 7.46037 14.1765 8.29304 14.1765C9.12656 14.1765 9.80412 14.854 9.80412 15.6876C9.80497 16.5211 9.12656 17.1986 8.29304 17.1986ZM18.7786 8.23792L20.098 10.4036H16.0727V8.23792H18.7786ZM17.7772 17.1271C16.9437 17.1271 16.2661 16.4495 16.2661 15.616C16.2661 14.7825 16.9437 14.1049 17.7772 14.1049C18.6107 14.1049 19.2883 14.7825 19.2883 15.616C19.2892 16.4487 18.6107 17.1271 17.7772 17.1271ZM21.2153 15.2742H19.9361C19.7707 14.2276 18.8699 13.4222 17.7773 13.4222C17.0852 13.4222 16.475 13.7504 16.0727 14.2524V11.0861H20.5132L21.2154 12.2392L21.2153 15.2742Z" fill="#FF6F00"/>
            <path d="M4.02939 9.19061H7.752C7.94036 9.19061 8.09291 9.03805 8.09291 8.8497C8.09291 8.66135 7.94036 8.50879 7.752 8.50879H4.02939C3.84103 8.50879 3.68848 8.66135 3.68848 8.8497C3.68848 9.03805 3.84018 9.19061 4.02939 9.19061Z" fill="#FF6F00"/>
            <path d="M6.0364 13.2931C6.0364 13.1047 5.88384 12.9521 5.69549 12.9521H3.94833C3.75998 12.9521 3.60742 13.1047 3.60742 13.2931C3.60742 13.4814 3.75998 13.634 3.94833 13.634H5.69549C5.88384 13.634 6.0364 13.4814 6.0364 13.2931Z" fill="#FF6F00"/>
            <path d="M7.47209 11.0709C7.47209 10.8825 7.31953 10.73 7.13118 10.73H2.30478C2.11642 10.73 1.96387 10.8825 1.96387 11.0709C1.96387 11.2592 2.11642 11.4118 2.30478 11.4118H7.13118C7.31953 11.4118 7.47209 11.2592 7.47209 11.0709Z" fill="#FF6F00"/>
          </svg>
          FREE shipping</span>
        </div>

        <div class="rc-frequency-label">Choose Frequency</div>
      `;

      sellingPlans.before(extra);

      /* ---------- FOOTER ---------- */
      const footer = document.createElement("div");
      footer.className = "rc-footer-text";
      footer.innerHTML = `
        <span class="rc-check">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M8.80167 12.0767L6.72167 9.99667C6.64333 9.91889 6.5475 9.87722 6.43417 9.87167C6.32083 9.86611 6.22 9.90778 6.13167 9.99667C6.04333 10.0856 5.99889 10.1839 5.99833 10.2917C5.99778 10.3994 6.04222 10.4978 6.13167 10.5867L8.33 12.785C8.46444 12.92 8.62139 12.9875 8.80083 12.9875C8.98028 12.9875 9.1375 12.92 9.2725 12.785L13.8367 8.22167C13.9144 8.14333 13.9561 8.0475 13.9617 7.93417C13.9672 7.82083 13.9256 7.72 13.8367 7.63167C13.7478 7.54333 13.6494 7.49889 13.5417 7.49833C13.4339 7.49778 13.3356 7.54222 13.2467 7.63167L8.80167 12.0767ZM10.0025 17.5C8.96583 17.5 7.99083 17.3033 7.0775 16.91C6.16472 16.5161 5.37056 15.9817 4.695 15.3067C4.01944 14.6317 3.48472 13.8383 3.09083 12.9267C2.69694 12.015 2.5 11.0403 2.5 10.0025C2.5 8.96472 2.69694 7.98972 3.09083 7.0775C3.48417 6.16472 4.01778 5.37056 4.69167 4.695C5.36556 4.01944 6.15917 3.48472 7.0725 3.09083C7.98583 2.69694 8.96083 2.5 9.9975 2.5C11.0342 2.5 12.0092 2.69694 12.9225 3.09083C13.8353 3.48417 14.6294 4.01806 15.305 4.6925C15.9806 5.36694 16.5153 6.16056 16.9092 7.07333C17.3031 7.98611 17.5 8.96083 17.5 9.9975C17.5 11.0342 17.3033 12.0092 16.91 12.9225C16.5167 13.8358 15.9822 14.63 15.3067 15.305C14.6311 15.98 13.8378 16.5147 12.9267 16.9092C12.0156 17.3036 11.0408 17.5006 10.0025 17.5Z" fill="#2E2E2E"/>
        </svg>
        </span>
        Pause or cancel anytime, no commitment
      `;
      label.appendChild(footer);

      // === One time Purchase ===
      document.querySelectorAll('label.rc-radio.onetime-radio .rc-radio__label').forEach(label => {
        const text = label.textContent.trim();

        const match = text.match(/^(.*?)(\$\d+(?:\.\d{2})?)$/);

        if (!match) return;

        label.innerHTML = `
          <span class="label-text">${match[1].trim()}</span>
          <span class="label-price">${match[2]}</span>
        `;
      });

      clearInterval(rcInterval); // stop checking
    }, 300);


    const rechargeInterval = setInterval(() => {
    const sellingPlans = document.querySelector(".rc-selling-plans");
    const targetLabel = document.querySelector("label.rc-radio.subscription-radio");

      if (sellingPlans && targetLabel) {
        if (!targetLabel.contains(sellingPlans)) {
          targetLabel.appendChild(sellingPlans);
        }

        clearInterval(rechargeInterval); // stop once done
      }
    }, 300);

   // ================ END : Richarge Widget design  ================== 

   // ================ Start : PDP Append the offer product section to the right side on mobile.  ================== 

    const offerSection = document.querySelector(".offer-product-section");
    const leftGrid = document.querySelector(".product__grid-left");
    const rightGridTarget = document.querySelector(
      ".product__grid-right .product-image-with-text"
    );

    if (!offerSection || !leftGrid || !rightGridTarget) return;

    const placeholder = document.createElement("div");
    placeholder.style.display = "none";
    offerSection.parentNode.insertBefore(placeholder, offerSection);

    const mediaQuery = window.matchMedia("(max-width: 1020px)");

    function handleLayoutChange(e) {
      if (e.matches) {
        rightGridTarget.insertAdjacentElement("afterend", offerSection);
      } else {
        placeholder.insertAdjacentElement("afterend", offerSection);
      }
    }

    handleLayoutChange(mediaQuery);

    mediaQuery.addEventListener("change", handleLayoutChange);

    // ================ End : PDP Append the offer product section to the right side on mobile.  ================== 

  }




  // ================ ******************** End : PDP JS ******************  ================== 


  
if (document.body.classList.contains('routine-creatine')) {


}






});


document.addEventListener("DOMContentLoaded", function () {
  const priceEl = document.querySelector(".product__price .money, .product-price-minimum");

if (priceEl) {
  const observer = new MutationObserver(() => {

    const oneTimeEl = document.querySelector(".rc-widget .onetime-radio .label-price");
    const subEl = document.querySelector(".rc-widget .subscription-radio strong");

    if (!oneTimeEl && !subEl) return;

    // price text
    let priceText = priceEl.textContent.trim();

    // number extract (₹1,299 → 1299)
    let numeric = parseFloat(priceText.replace(/[^0-9.]/g, ""));

    if (!numeric) return;

    // 10% discount
    let discounted = (numeric * 0.9).toFixed(2);

    // currency symbol detect
    let symbol = priceText.replace(/[0-9.,\s]/g, "");

    // formatted discount price
    let discountPrice = symbol + discounted;

    // update DOM
    if (oneTimeEl) oneTimeEl.textContent = priceText;
    if (subEl) subEl.textContent = discountPrice;

    console.log("Updated:", priceText, discountPrice);

  });

  observer.observe(priceEl, {
    childList: true,
    subtree: true,
    characterData: true
  });
}


document.addEventListener("click", function(e){
  const opt = e.target.closest(".custom-options");
  if(!opt) return;

  const value = opt.getAttribute("value");

  const select = document.querySelector(".option-select .single-option-selector");
  if(!select) return;

  const option = [...select.options].find(o => o.text.trim() === value || o.value === value);
  if(!option) return;

  select.value = option.value;

  // change event trigger
  select.dispatchEvent(new Event("change", { bubbles:true }));

  // optional click trigger (agar theme click listener use karti ho)
  option.dispatchEvent(new Event("click", { bubbles:true }));
});

});


  




